import { gql } from '@apollo/client';
import { ProductFragments, queryRequiresZipCode } from '../product/getProductQuery';
import { spreadGroupedDomains } from '../../react/util';

export const RelatedSearchFragments = {
  relatedSearch: {
    name: 'RelatedSearch',
    fragment: gql`
      fragment RelatedSearch on RelatedSearchModel {
        relatedSearch {
          url
          anchor
          __typename
        }
      }
    `
  },
  products: {
    name: 'ProductsDetails',
    fragment: (productDomains) => gql`
    fragment ProductsDetails on RelatedSearchModel {
        products {
            ${productDomains.map((domain) => `...${ProductFragments[domain].name}`).join('\n')}
            dataSources
            isBrowseOnly @client
            fulfillmentMethod @client
            itemId
            __typename
        }
    }
    `
  }
};

const getRelatedQuery = ({ domains = [], productDomains: initialProductDomains = [] } = {}) => {
  const productDomains = spreadGroupedDomains({ domains: initialProductDomains });
  let fragmentRelatedSearchDomains = [...domains];
  let fragmentProductDomains = [...productDomains];

  if (fragmentRelatedSearchDomains.length === 0) {
    fragmentRelatedSearchDomains = [
      'relatedSearch'
    ];
  }

  const AVAILABLE_DOMAINS = Object.keys(RelatedSearchFragments);

  const missingDomains = fragmentRelatedSearchDomains.filter((domain) => AVAILABLE_DOMAINS.indexOf(domain) === -1);
  if (missingDomains.length) {
    throw new Error(`The following search domains do not exist: ${missingDomains.join(', ')}.`);
  }

  const params = ['$navParam: String', '$storeId: String', '$itemId: String'];
  if (queryRequiresZipCode({ domains: productDomains })) {
    params.push('$zipCode: String');
  }

  const RelatedQuery = `
  query RelatedSearch(${params.join(', ')}) {
    relatedSearchModel(navParam: $navParam, storeId: $storeId, itemId: $itemId) {
      ${fragmentRelatedSearchDomains.map((domain) => `...${RelatedSearchFragments[domain].name}`).join('\n')}
      __typename
    }
  }
  ${fragmentRelatedSearchDomains
    .map(
      (domain) => (typeof RelatedSearchFragments[domain].fragment === 'function'
        ? RelatedSearchFragments[domain].fragment(productDomains).loc.source.body
        : RelatedSearchFragments[domain].fragment.loc.source.body)
    )
    .join('\n ')}
  ${fragmentProductDomains
    .map((domain) => ProductFragments[domain].fragment.loc.source.body)
    .join('\n')}
`;

  return gql(RelatedQuery);
};

export default getRelatedQuery;
